import { createActions } from "../../helpers/utils/createActions";
import { DOCUMENT } from "./actionTypes";

export const getListaDocument = createActions(DOCUMENT.GET_LIST);
export const getDocument = createActions(DOCUMENT.GET_DOCUMENT);
export const saveDocument = createActions(DOCUMENT.SAVE_DOCUMENT);
export const duplicateDocument = createActions(DOCUMENT.DUPLICATE_DOCUMENT);

export const getDocumentHistory = createActions(DOCUMENT.GET_DOCUMENT_HISTORY);
export const getDocumentHistoryList = createActions(DOCUMENT.GET_DOCUMENT_HISTORY_LIST);
export const getDocumentAll = createActions(DOCUMENT.GET_DOCUMENT_ALL);
export const getDocumentProducts = createActions(DOCUMENT.GET_DOCUMENT_PRODUCTS);
export const getDocumentSnippets = createActions(DOCUMENT.GET_DOCUMENT_SNIPPETS);
export const getDocumentSections = createActions(DOCUMENT.GET_DOCUMENT_SECTIONS);

export const getDocumentPreview = createActions(DOCUMENT.GET_DOCUMENT_PREVIEW);

export const getDownloadDocument = createActions(DOCUMENT.GET_DOWNLOAD_DOCUMENT);

export const postDocumentDownloadList = createActions(DOCUMENT.POST_DOCUMENT_DOWNLOAD_LIST);

export const getDocumentDownloadHistory = createActions(DOCUMENT.GET_DOCUMENT_DOWNLOAD_HISTORY);

export const putDocumentBulkStatusUpdate = createActions(DOCUMENT.PUT_DOCUMENT_BULK_STATUS_UPDATE);

export const loadEmptyDocument = () => ({ type: DOCUMENT.LOAD_EMPTY });
export const cleanMessageDocument = () => ({ type: DOCUMENT.CLEAN_MESSAGE });
export const disableLoadingDocument = () => ({ type: DOCUMENT.DISABLE_LOADING_DOCUMENT });
export const cleanIdDocumentDuplicate = () => ({ type: DOCUMENT.CLEAN_ID_DOCUMENT_DUPLICATE });
export const changePageSizeDocument = (payload) => ({ type: DOCUMENT.CHANGE_PAGE_SIZE_DOCUMENT, payload });